"use strict";

/**
* Initializes event handlers for the vehicle selector component.
* - Handles dropdown changes to trigger AJAX requests for vehicle filtering and updates the UI accordingly.
* - Manages tab switching by toggling active states and displaying the relevant tab content.
* - Submits the vehicle search form when the search button is clicked.
*
* @function
* @returns {void}
*/
function init() {
    $(".vehicle-selector-dropdown").on("change", function () {
        var $this = $(this);
        var selectedValue = $this.val();
        var selectedFilter = $this.data("filterby");
        var url = $(".vehicle-selector-container").data("url");
        var isSearchRestrictedToFordVehicles = $(".vehicle-selector-container").data("isRestrictedToFordVehicles");

        if (url) {
            $.spinner().start();
            $.ajax({
                url: url,
                data: {
                    selectedFilter: selectedFilter,
                    selectedValue: selectedValue,
                    isSearchRestrictedToFordVehicles: isSearchRestrictedToFordVehicles
                },
                method: "GET",
                success: function (response) {
                    // updates the dropdowns refinements based on the selected filters
                    $(".js-vehicle-selector-dropdowns").html(response);
                    init();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $(".vehicle-selector-tab").on("click", function () {
        var $this = $(this);
        var isActive = $this.hasClass("active");

        if (isActive) {
            return;
        }

        // removes the active class from all tabs and adds it to the selected one
        $(".vehicle-selector-tab").removeClass("active");
        $this.addClass("active");

        // hides all tab containers and shows only the selected one
        var tabContainer = $this.data("tab-container");

        $(".vehicle-selector-tab-container").addClass("d-none");
        $("." + tabContainer).removeClass("d-none");
    });

    $("#vehicle-selector-search-btn").on("click", function (e) {
        e.preventDefault();
        $(".vehicle-selector-searcher").find("form").submit();
    });

    // listener for the remove vehicle button in the PDP
    $(".js-vehicle-selector-pdp-remove").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var url = $this.data("url");
        var href = $this.attr("href");

        if (url) {
            $.spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function () {
                    $.spinner().stop();

                    if (href) {
                        window.location.href = href;
                    } else {
                        location.reload(true);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    // listener for search button in the home page
    $("#js-vehicle-selector-search-button").on("click", function (e) {
        e.preventDefault();

        var url = $(this).attr("href");
        var filterCounter = 1;

        $(".vehicle-selector-dropdown").each(function () {
            var $this = $(this);
            var selectedValue = $this.val();
            var filterBy = $this.data("filterby");

            if (selectedValue !== "0" && filterBy) {
                url += "&prefn" + filterCounter + "=" + filterBy + "&prefv" + filterCounter + "=" + selectedValue;
                filterCounter++;
            }
        });

        window.location.href = url;
    });
}

export default function vehicleSelector() {
    init();
}
